import {Component, OnInit} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {LoginService} from '../../shared/services/login.service';
import {HttpErrorResponse} from '@angular/common/http';
import {SdaiService} from '../../create-application/sdai-form/sdai.service';
import { FeatureToggleService } from '../../shared/services/feature-toggle.service';
import { FeatureToggle } from '../../shared/data-objects/feature-toggle';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-check-app-status',
  templateUrl: './check-app-status.component.html',
  styleUrls: ['./check-app-status.component.css']
})
export class CheckAppStatusComponent implements OnInit {

  DAMSApplicationIdRE = /^(LND|CMP|SPA|BOE|PFI|FAI|SRA)\/[0-9][0-9]\/[0-9]{5}$/i;
  numberOnlyRE = /^[0-9]+$/;

  DAMSApplicationId: string;
  paymentRefNum = '';
  validationSummary: string;

  applicationDate: string;
  locationAddress: string;
  refNum: string;
  applicationType: string;
  applicationStatus: string;
  statusChangeDate: string;
  ApplicationCurrentlyAt: string;
  ApplicationDueDays: string;
  paymentRefNumVisible = true;
  isRequesting = false;

  paymentRefNumControl: FormControl;
  DAMSApplicationIdControl: FormControl;

  DAMSApplicationIdControlLength = 12;
  paymentRefNumControlLength = 10;
  _feature: FeatureToggle;

  constructor(private loginService: LoginService, private applicationService: SdaiService, 
              private activatedRoute: ActivatedRoute, private featureToggleService: FeatureToggleService) {

    this.DAMSApplicationIdControl = new FormControl('', [Validators.compose([
      Validators.required,
      Validators.maxLength(this.DAMSApplicationIdControlLength), Validators.minLength(this.DAMSApplicationIdControlLength),
      Validators.pattern(this.DAMSApplicationIdRE)])
    ]);

    this.paymentRefNumControl = new FormControl('', [Validators.compose([
      Validators.maxLength(this.paymentRefNumControlLength),
      Validators.pattern(this.numberOnlyRE)])
    ]);

    this.activatedRoute.url.subscribe(async url =>{
      await this.getFeatureToggle();
      if(this._feature && !this._feature.DisableGuestUsers && !this.loginService.isUserLoggedIn()) {
        this.loginService.guestLogin(this.guestLoginOkCb.bind(this), this.guestLoginErrorCb.bind(this));
      }
    });
  }

  async ngOnInit(){}

  async getFeatureToggle() {
    this._feature = this.featureToggleService.features;
    if (!this._feature) {
      await this.featureToggleService.fetchFeatureToggles();
      this._feature = this.featureToggleService.features;
    }
  }

  guestLoginOkCb(ok: boolean): void {
    if (typeof (ok) === 'boolean') {
      if (!ok) {
        this.validationSummary = 'Error occurred while logging in guest user.';
      } else {
      }
    }
  }

  guestLoginErrorCb(err: HttpErrorResponse): void {
    this.validationSummary = err.error.message;
  }
  isValid(): boolean {
    if (this.DAMSApplicationIdControl.invalid ) {
      this.validationSummary = 'Please enter Valid Reference Number';
      return false;
    }
    if ((!this.DAMSApplicationId.toUpperCase().startsWith('LND') && !this.DAMSApplicationId.toUpperCase().startsWith('SRA') )&& !this.paymentRefNum) {
      this.validationSummary = 'Please enter Valid Payment Reference Number';
      return false;
    }
    // if (!this.DAMSApplicationId.toUpperCase().startsWith('SRA')) {
    //   this.validationSummary = 'Please enter Valid Payment Reference Number';
    //   return false;
    // }
    if (this.paymentRefNum && this.paymentRefNumControl.invalid) {
      this.validationSummary = 'Please enter Valid Payment Reference Number';
      return false;
    }
    return true;
  }
  changedDamsApplication() {
    if (this.DAMSApplicationIdControl.invalid ) {
      this.paymentRefNumVisible = true;
      return;
    }
if(this.DAMSApplicationId.toUpperCase().startsWith('SRA'))

{
    this.paymentRefNumVisible = !this.DAMSApplicationId.toUpperCase().startsWith('SRA')
    return;
}
    this.paymentRefNumVisible = !this.DAMSApplicationId.toUpperCase().startsWith('LND')
   
    return;
    
  }
  checkStatus() {
    this.DAMSApplicationIdControl.markAsTouched();
    if (!this.isValid()) {
      return;
    }
    this.isRequesting = true;
    this.validationSummary = '';
    this.applicationService.checkStatus(this.loginService.getToken(),
      this.DAMSApplicationId, this.paymentRefNum).subscribe((data: any) => {
      this.isRequesting = false;
      const ah: any = data.Application;
      if (ah == null || (!ah.applicationDate && !ah.status && !ah.statusChangeDate
          && !ah.locationAddress && !ah.refNum && !ah.applicationType)) {
        this.validationSummary = 'Application not found';
        this.applicationDate = '';
        this.applicationStatus = '';
        this.statusChangeDate = '';
        this.locationAddress = '';
        this.refNum = '';
        this.applicationType = '';
      } else {
        this.applicationDate = ah.applicationDate;
        this.applicationStatus = ah.status;
        this.statusChangeDate = ah.statusChangeDate;
        this.locationAddress = ah.locationAddress;
        this.refNum = ah.refNum;
        this.applicationType = ah.applicationType;
        this.ApplicationCurrentlyAt = data.ApplicationCurrentlyAt;
        this.ApplicationDueDays = data.ApplicationDueDays;
      }
    }, err => {
      // Log errors if any
      this.isRequesting = false;
      this.validationSummary = 'Application not found';
      this.applicationDate = '';
      this.applicationStatus = '';
      this.statusChangeDate = '';
      this.locationAddress = '';
      this.refNum = '';
      this.applicationType = '';
      console.log(err);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-applications/check-app-status/check-app-status.component.ts